import React, { useState } from 'react'
import { Container, InputContainer } from './styled'
import { Card } from './Card'
import { Button } from '../../../../components/common/Button'
import { Modal } from '../../../../components/Modal'

export const Warnings = ({ markOnClick, viewOnClick, data }) => {
  const [confirmMarkAsRead, setConfirmMarkAsRead] = useState<boolean>(false)

  return (
    <Container>
      <InputContainer width="fit-content">
        <Button.Root
          backgroundColor="#989898"
          onClick={() => setConfirmMarkAsRead((prev) => !prev)}
        >
          <Button.Content title="Marcar como lido" color="#fff" />
        </Button.Root>
      </InputContainer>
      {data.map((el) => (
        <Card onclick={viewOnClick} key={el.id} data={el} />
      ))}

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirmMarkAsRead}
        setIsOpenController={() => setConfirmMarkAsRead(false)}
      >
        <Modal.Header onclick={() => setConfirmMarkAsRead(false)} />
        <Modal.Content
          value="Você deseja marcar como visto?"
          subvalue="Ao clicar em SIM, as notificações irão ser marcadas como vistas"
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => {
              setConfirmMarkAsRead((prev) => !prev)
            }}
          >
            <Button.Content title="Não" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              markOnClick(['all'])
              setConfirmMarkAsRead(false)
            }}
          >
            <Button.Content title="Sim" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </Container>
  )
}
